import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCompact(value: number): string {
  return new Intl.NumberFormat('fr-FR', { 
    notation: 'compact', 
    maximumFractionDigits: 1 
  }).format(value);
}

export function getDifficultyColor(difficulty: string): string {
  const normalized = difficulty.toLowerCase();
  switch (normalized) {
    case 'débutant':
    case 'facile':
    case 'easy':
      return 'bg-success text-success-foreground';
    case 'intermédiaire':
    case 'moyen':
    case 'medium':
      return 'bg-warning text-warning-foreground';
    case 'avancé':
    case 'difficile':
    case 'hard':
      return 'bg-destructive text-destructive-foreground';
    case 'expert':
      return 'bg-purple-500 text-white';
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export function safePercentage(numerator: number, denominator: number): number {
  if (denominator === 0) return 0;
  return Math.round((numerator / denominator) * 100);
}
